import {Pipe, PipeTransform} from '@angular/core';

@Pipe({standalone: true, name: 'averagePipe'})
export class AveragePipe implements PipeTransform
{
  public static getAverage(score: number, darts: number, oneDart?: boolean): number
  {
    const avg = score / darts * (oneDart ? 1.0 : 3.0);
    if (avg <= 180)
      return (Math.round(avg * 10) / 10.0);
    else return 0;
  }

  public static getAverageStr(score: number, darts: number, digits: number, withSign: boolean, oneDart?: boolean): string
  {
    const avg = score / darts * (oneDart ? 1.0 : 3.0);
    if (avg <= 180)
      return (withSign ? 'Ø ' : '') + (Math.round(avg * 10) / 10.0).toFixed(digits);
    else return '';
  }

  public static formatAverage(avg: number, withSign: boolean): string
  {
    if (avg >= 0 && avg <= 180)
      return (withSign ? 'Ø ' : '') + (Math.round(avg * 10) / 10.0);
    else return '';
  }

  transform(score: number, numberOfDarts: number, withSign: boolean = true): string
  {
    // console.log('AveragePipe transform: ');
    return AveragePipe.getAverageStr(score, numberOfDarts, 1, withSign);
    /*if (matchPlayer)
    {
      if (matchPlayer.dartsTotal > 0 && matchPlayer.scoreTotal > 0)
      {
        const avg = matchPlayer.scoreTotal / matchPlayer.dartsTotal * 3.0;
        return (Math.round(avg * 10) / 10.0).toFixed(1);
      }
    }
    return '-';*/
  }
}
